import Vue from "vue";
import Vuex from "vuex";
import * as SharedStore from "./signup/shared/store";
import ConnectBankAccounts from "./components/ConnectBankAccounts.vue";
import { initializeLogRocketSessionCache } from "./auth/loans/onboarding/logrocketSessionCache";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require("./app/bootstrap");
require("./auth/templates");

// Marketplace-only observability bridge. Views without an authenticated loan context
// (including signup-bank-info and leadgen unsubscribe) take the tested no-op path.
initializeLogRocketSessionCache(window.marketplaceLogRocketSessionContext);

// require("./new-design/new-templates");

// require("./new-design/steppingstone/steppingstone_templates");

// new themes
require("./themes/aurora/aurora_templates");
require("./themes/phoenix/phoenix_templates");

window.Vue = require("vue").default;
Vue.use(Vuex);

Vue.filter('capitalize', require('./utils').capitalize);

import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
    el: "#app",
    store: SharedStore.default,

    components: {
        Account: require("./auth/Account").default,
        ChangeBank: require("./auth/ChangeBank").default,
        ChangeBankRequired: require("./auth/ChangeBankRequired").default,
        Dashboard: require("./auth/Dashboard").default,
        LoanDashboard: require("./auth/loans/Dashboard").default,
        LoanSetDeposit: require("./auth/loans/onboarding/SetDeposit").default,
        LoanSignDocuments: require("./auth/loans/onboarding/SignDocuments").default,
        LoanPending: require("./auth/loans/onboarding/Pending").default,
        LoanNotAllowedToSell: require("./auth/loans/onboarding/LoanNotAllowedToSell").default,
        LoanExpired: require("./auth/loans/onboarding/Expired").default,
        IntroxlReapply: require("./auth/loans/onboarding/IntroxlReapply").default,
        IntroxlRefi: require("./auth/loans/onboarding/IntroxlRefi").default,
        IntroxlRefiCashBack: require("./auth/loans/onboarding/IntroxlRefiCashBack").default,
        IntroxlRefiSamples: require("./auth/loans/onboarding/IntroxlRefiSamples").default,
        RefinanceAlreadyComplete: require("./auth/introxl/refinance/pages/RefinanceAlreadyComplete").default,
        LoanApplicationIncomplete: require("./auth/loans/onboarding/ApplicationIncomplete").default,
        LoanDenied: require("./auth/loans/onboarding/Denied").default,
        LoanLeadgenPartner: require("./auth/loans/onboarding/LeadgenPartner").default,
        IntroxlRejected: require("./auth/loans/onboarding/IntroxlRejected").default,
        AddressVerification: require("./auth/loans/onboarding/AddressVerification").default,
        LoanScheduled: require("./auth/loans/onboarding/Scheduled").default,
        UtilityBillUpload: require("./auth/loans/onboarding/UtilityBillUpload").default,
        PlaidWaiting: require("./auth/loans/onboarding/PlaidWaiting").default,
        LoanVerifyAccount: require("./auth/loans/onboarding/Verify").default,
        CustomPaystubUpload: require("./auth/loans/onboarding/CustomPaystubUpload").default,
        LoanVerifyIncome: require("./auth/loans/onboarding/IncomeVerification").default,
        LoanVerifyIncomeProcessing: require("./auth/loans/onboarding/IncomeVerificationProcessing").default,
        LoanVerifyIncomeSetBankAccountNumber: require("./auth/loans/onboarding/IncomeVerificationSetBankAccountNumber").default,
        LoanVerifyIdentity: require("./auth/loans/onboarding/IdentityVerification").default,
        LoanVerifyIdentityProcessing: require("./auth/loans/onboarding/IdentityVerificationProcessing.vue").default,
        UnverifiedIncome: require("./auth/loans/onboarding/UnverifiedIncome").default,
        LoanConfirmPayment: require("./auth/loans/payments/ConfirmPayment").default,
        LoanRecoverPayment: require("./auth/loans/payments/RecoverPayment").default,
        LoanOneMoment: require("./auth/loans/onboarding/Pause").default,
        LoanOneMomentUnbranded: require("./auth/loans/onboarding/PauseUnbranded").default,
        LoanWelcome: require("./auth/loans/onboarding/Welcome").default,
        LoanWelcomeLeadgen: require("./auth/loans/onboarding/WelcomeLeadgen").default,
        Profile: require("./auth/Profile").default,
        PlaidUpdateMode: require("./auth/PlaidUpdateMode").default,
        Unsubscribe: require("./auth/Unsubscribe").default,
        LeadgenUnsubscribe: require("./auth/LeadgenUnsubscribe").default,
        ConnectBankAccounts: require("./components/ConnectBankAccounts").default,
        AdditionalBankInformation: require("./signup/original/pages/AdditionalBankInformation.vue").default,

        // NewLoanWelcome: require("./new-design/pages/loans/onboarding/Welcome").default,
        // NewLoanVerify: require("./new-design/pages/loans/onboarding/Verify").default,

        // StepProgress: require("./components/StepProgress").default,
        // BoxContent: require("./components/BoxContent").default,
        // ListInfo: require("./components/ListInfo").default,
        // AppButton: require("./components/AppButton").default,
        // BoxAction: require("./components/BoxAction").default,
        // Divider: require("./components/Divider").default,

        // NewLayout: require("./new-design/NewLayout").default,

        // steppingstone pages 
        // SteppingStoneVerify: require("./new-design/steppingstone/page/loans/onboarding/SteppingStoneVerify.vue").default,
        // SteppingStoneWelcome: require("./new-design/steppingstone/page/loans/onboarding/SteppingStoneWelcome.vue").default,


        // new themes 
        // aurora 
        AuroraWelcome: require("./themes/aurora/pages/loans/onboarding/AuroraWelcome").default,
        AuroraWelcomeLeadgen: require("./themes/aurora/pages/loans/onboarding/AuroraWelcomeLeadgen").default,
        AuroraVerify: require("./themes/aurora/pages/loans/onboarding/AuroraVerify").default,
        AuroraIncomeVerification: require("./themes/aurora/pages/loans/onboarding/AuroraIncomeVerification").default,
        AuroraPlaidUpdateMode: require("./themes/aurora/pages/AuroraPlaidUpdateMode").default,

        // phoenix
        PhoenixWelcome: require("./themes/phoenix/pages/loans/onboarding/PhoenixWelcome").default,
        PhoenixWelcomeLeadgen: require("./themes/phoenix/pages/loans/onboarding/PhoenixWelcomeLeadgen").default,
        PhoenixVerify: require("./themes/phoenix/pages/loans/onboarding/PhoenixVerify").default,
        PhoenixIncomeVerification: require("./themes/phoenix/pages/loans/onboarding/PhoenixIncomeVerification").default,
        PhoenixPlaidUpdateMode: require("./themes/phoenix/pages/PhoenixPlaidUpdateMode").default,
    },

    created() {
        this.app = {
            ...window.app,
            mailtoSupport: `mailto:${window?.app?.support_email}`,
        };
        this.user = JSON.parse(window.user)
        this.viewNova = window.can_view_nova;
        this.theme = window.theme;
        this.isImpersonating = window.is_impersonating;

        this.$on("updateUser", (newUser) => {
            Object.keys(newUser).forEach((key) => {
                if (this.user.hasOwnProperty(key) && this.user[key] !== newUser[key]) {
                    this.user[key] = newUser[key];
                }
            });
        });

        window.Echo = new Echo({
            broadcaster: 'reverb',
            key: window.reverb_key,
            wsHost: window.reverb_host,
            wsPort: window.reverb_port ?? 80,
            wssPort: window.reverb_port ?? 443,
            forceTLS: (window.reverb_scheme ?? 'https') === 'https',
            enabledTransports: ['ws', 'wss'],
        });
    },

    mounted() {
        if (this.user) {
            window.Echo.private('user-channel.' + this.user.id)
                .subscribed(() => {
                    console.log(`Successfully subscribed to user-channel`);
                })
                .listen("MarketplaceSold", (e) => {
                    if (e && e.data) {
                        // Offer the news to a mounted handoff owner first. The pause page
                        // knows whether this event is about the loan it is showing and
                        // whether a handoff is already under way; a blind reload could
                        // restart the wait or abandon a navigation in flight. A listener
                        // claims the event by calling preventDefault().
                        const claimed = !window.dispatchEvent(new CustomEvent('marketplace:sold', {
                            cancelable: true,
                            detail: {
                                loanId: e.loan_id ?? null,
                                marketplaceSaleId: e.marketplace_sale_id ?? null,
                            },
                        }));

                        // Nothing owns the handoff on this page, so the existing behaviour
                        // stands: reload and let the server render whatever is true now.
                        if (!claimed) {
                            setTimeout(() => {
                                window.location.reload();
                            });
                        }
                    } else {
                        console.error("Invalid event data:", e);
                    }
                }).listen("LoanStateCompletedEvent", (e) => {
                    setTimeout(() => {
                        window.location.reload();
                    })
                });

            window.Echo.connector.pusher.connection.bind('connected', (e) => {
                console.log("Pusher connected", e);
            });

            /*window.Echo.connector.pusher.connection.bind('disconnected', () => {
            });
            window.Echo.connector.pusher.connection.bind('connected', () => {
            });
            window.addEventListener('beforeunload', () => {
            });*/
        }
    },

    data() {
        return {
            app: null,
            user: null,
            viewNova: false,
            isImpersonating: false,
        };
    },
});
